export class Location {
    longitude: number;
    latitude: number;
}